import { CratesDataSourceService } from './../../core/data-sources/crates-data-source.service';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Pallet } from '../stock-levels-model/stock-levels-modal.component';
import { MapPalletDetailsComponent } from 'src/app/shared/map-pallet-details/map-pallet-details.component';
import { PigeonholeDetails, PigeonholePositionInfo } from 'src/models/Pigeonhole';
import { PigeonholeService } from 'src/app/core/data-sources/v3/pigeonhole/pigeonhole.service';
import { toExcelFormat } from 'src/app/helpers/format-position';

interface PigeonholeMapPositionDetailsModalDataInterface {
  positionInfo: PigeonholePositionInfo & { coords: string };
  qrCode: string;
  selectedTabIndex?: number;
  scrollTo?: string;
}

@Component({
  selector: 'app-pigeonhole-map-position-details-modal',
  templateUrl: './pigeonhole-map-position-details-modal.component.html',
  styleUrls: ['./pigeonhole-map-position-details-modal.component.scss']
})
export class PigeonholeMapPositionDetailsModalComponent implements OnInit {
  @ViewChild(MapPalletDetailsComponent) palletDetailsComponent: MapPalletDetailsComponent;
  title = '';
  showPalletDetails = false;
  showPositionDetails = true;
  packages: Pallet[] = [];
  palletDetails;
  pallet: Pallet;
  pigeonholeDetails: PigeonholeDetails;

  constructor(
    public dialogRef: MatDialogRef<PigeonholeMapPositionDetailsModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: PigeonholeMapPositionDetailsModalDataInterface,
    private crateService: CratesDataSourceService,
    private pigeonholeService: PigeonholeService
  ) { }

  ngOnInit(): void {
    this.getDetails();
  }

  async getDetails() {
    if (!this.data?.qrCode) return;
    const details = await this.pigeonholeService.getPigeonholeDetails(this.data.qrCode);
    this.packages = details.packages || [];
    this.data.positionInfo = {  ...this.data.positionInfo };
    this.pigeonholeDetails = details.pigeonhole;
    this.pigeonholeDetails.coords = `${toExcelFormat(details.pigeonhole.column, details.pigeonhole.row)} (x:${details.pigeonhole.column} y:${details.pigeonhole.row})`;
    this.setTitle(details.pigeonhole.alias);  
  }

  async onChangeToPallet(pallet: Pallet) {
    const itemDetails = await this.crateService.getCrateById(pallet.id).then((r: any) => {
      r.invoice = r.crate.invoices[0];
      return r;
    });
    this.palletDetails = {
      item: pallet,
      itemDetails: itemDetails,
      isExit: false
    };
    this.pallet = pallet;
    this.showPalletDetails = true;
    this.showPositionDetails = false;
    this.setTitle(null);
  }

  goBackToMap() {
    if (this.showPalletDetails && this.palletDetailsComponent?.isNavigatedPallet) {
      this.palletDetailsComponent.goBackToPreviousPallet();
      return;
    }
    this.showPositionDetails = true;
    this.showPalletDetails = false;
    this.data.selectedTabIndex = 1;
    this.data.scrollTo = this.pallet.tagRfid;
    this.setTitle(this.pigeonholeDetails.alias);
  }

  close() {
    this.dialogRef.close();
  }

  setTitle(alias: string) {
    if (this.showPalletDetails) {
      this.title = 'Dados Do Pallet';
      return;
    }
    this.title = alias ?? '---';
  }

}
